import * as React from "react";

import { EventContext } from "@/components/event-provider/event-provider-component";

export default function useEvent() {
  return React.useContext(EventContext);
}
